import _ from 'lodash';
import * as Models from 'models';

export function resetInlineStylesOnRelation<S extends Models.EditorDependentStyles>(styles: S): S {
  return _.chain(styles)
    .cloneDeep()
    .set('fontColor', [])
    .set('fontSize', [])
    .set('fontFamily', [])
    .set('fontStyle', [])
    .set('fontWeight', [])
    .set('characterStyleName', [])
    .set('lineHeight', {})
    .set(['alignment', 'horizontal'], {})
    .value();
}
